export const SMALL_AUDIT_LOCKED_SECTIONS: Array<{ id: string; labelKey: string }> = [
  { id: 'pricing-analysis', labelKey: 'amazonAudit.sections.pricingAnalysis' },
  { id: 'review-insights', labelKey: 'amazonAudit.sections.reviewInsights' },
  { id: 'brand-analysis', labelKey: 'amazonAudit.sections.brandAnalysis' },
  { id: 'compliance', labelKey: 'amazonAudit.sections.compliance' },
  { id: 'attribute-intelligence', labelKey: 'amazonAudit.sections.attributeIntelligence' },
  { id: 'competitive-benchmark', labelKey: 'amazonAudit.sections.competitiveBenchmark' },
  { id: 'conversion-drivers', labelKey: 'amazonAudit.sections.conversionDrivers' },
  { id: 'conversion-blockers', labelKey: 'amazonAudit.sections.conversionBlockers' },
  { id: 'product-improvements', labelKey: 'amazonAudit.sections.productImprovements' },
  { id: 'positioning', labelKey: 'amazonAudit.sections.positioning' },
]
